// API configuration
const API_BASE_URL = process.env.REACT_APP_API_URL || '';

export const getApiUrl = (endpoint) => {
  // If REACT_APP_API_URL is set, use it; otherwise use relative URLs (for proxy in dev)
  const url = `${API_BASE_URL}${endpoint}`;

  // In production, enforce HTTPS
  if (process.env.NODE_ENV === 'production' && url.startsWith('http://')) {
    console.warn('SECURITY WARNING: Upgrading insecure HTTP to HTTPS');
    return url.replace('http://', 'https://');
  }

  return url;
};

export default API_BASE_URL;
